
import axios from "../network/reuset"; // 导入http中创建的axios实例
import qs from "qs"; // 根据需求是否导入qs模块

const getTasks = {
  getTasksList(params) {
    return axios.post(
      `/api/admin/tasks/list`,
      qs.stringify(params)
    );
  },
  getTasksInfo(params) {
    return axios.post(
      `/api/admin/tasks/info`,
      qs.stringify(params)
    );
  },
  saveTasks(params) {
    return axios.post(
      `/api/admin/tasks/save`,
      qs.stringify(params)
    );
  },
  addTasks(params) {
    return axios.post(
      `/api/admin/tasks/add`,
      qs.stringify(params)
    );
  },
  delTasks(params) {
    return axios.post(
      `/api/admin/tasks/del`,
      qs.stringify(params)
    );
  },
  getTaskRunLogList(params) {
    return axios.post(
      `/api/admin/task_run_log/list`,
      qs.stringify(params)
    );
  },
};
export default getTasks;
